import { updateHandler } from "../utils";
export var getScheduleEndpoints = function (api) {
    return {
        updateSchedule: {
            invalidatesTags: ["getPlaceSlots", "getPlaceSchedules"],
            onQueryStarted: updateHandler("getScheduleById", "id", api),
        },
        createSchedule: {
            invalidatesTags: ["getPlaceSlots", "getPlaceSchedules"],
        },
        deleteSchedule: {
            invalidatesTags: ["getPlaceSlots", "getPlaceSchedules"],
        },
    };
};
